module.exports = __webpack_public_path__ + "static/Grafika1-de967b3ee264f142defc6c44d3bc9f2a.png";